import { AttributeValue } from "../../../library-js/dom-tools/AttributeValue";
import { ClassFlag } from "../../../library-js/dom-tools/ClassFlag";
import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { ElementSelector } from "../../../library-js/dom-tools/ElementSelector";
import { OnChange, OnClick, OnInput, OnKeyUp } from "../../../library-js/dom-tools/EventListeners";
import { URLHash } from "../../../library-js/dom/URLHash";
import { RegexValidator } from "../../../library-js/validators/RegexValidator";
import { EmailValidator } from "../../../library-js/validators/EmailValidator";
import { HTMLEditor } from "../../../library-js/dom-tools/HTMLEditor";
import { Rokojori } from "../Rokojori";
import { UserSignUpRequest } from "../../../library-js/php/user/UserSignUpRequest";
import { UserAccountCreationInput, UserCreateAccountRequest } from "../../../library-js/php/user/UserCreateAccountRequest";
import { UserAccountBlock } from "./UserAccountBlock";
import { copySync } from "fs-extra";
import { Overlay } from "../overlay/Overlay";
import { TimePin } from "../../../library-js/animation/TimePin";
import { UserLocales } from "../i8/UserLocales";
import { PageHandler } from "../../../library-js/dom-tools/PageHandler";
import { OverlayHint } from "../overlay/OverlayHint";

class DeleteAccountData
{
  email:string;
  tokenID:string;
  password:string;  
  

  get passwordIsValud()
  {
    return this.password.length > 8;
  }
  get valid()
  {
    return this.passwordIsValud;
  }
}

export class DeleteAccountUI
{
  static readonly attribute = new ElementAttribute( "delete" );
  static readonly selector  = new ElementSelector( UserAccountBlock.type, DeleteAccountUI.attribute );

  static readonly invalidInput   = new ClassFlag( "invalid-input" );
  static readonly validInput     = new ClassFlag( "valid-input" );
  static readonly successContent = new ElementType( "success-content" );
  static readonly errorContent   = new ElementType( "error-content" );

  private static _data = new Map<HTMLElement,DeleteAccountData>();

  static applyOnDocument()
  {
    DeleteAccountUI._data.clear();
    DeleteAccountUI.selector.forAllInDoc( e => DeleteAccountUI.applyOnElement( e ) );
  }

  static isValidHash()
  {
    let hash = URLHash.get();

    if ( hash == null )
    {
      return false;
    }

    let firstAt = hash.indexOf( "@" );

    if ( firstAt == -1 || firstAt == 0)
    {
      return false;
    }

    let id =  hash.substring( 0, firstAt );
    let email = hash.substring( firstAt + 1 );

    console.log( "Validating:", { id, email } );
    
    if ( ! RegexValidator.BASE64URL.validate( id ) )
    {
      console.log( "ID not valid");
      return false;
    }

    console.log( "ID valid");

    if ( EmailValidator.isValid( email ) )
    {
      console.log( "EMAIL not valid" );
      return false;
    }

    console.log( "EMAIL valid");

    return true;
  }

  static getEmailAndID()
  {
    let hash = URLHash.get();
    let firstAt = hash.indexOf( "@" );
    
    let id =  hash.substring( 0, firstAt );

    let email = hash.substring( firstAt + 1 );

    return { id, email };
  }

  

  static applyOnElement( e:HTMLElement )
  {
    if ( ! DeleteAccountUI.isValidHash() )
    {
      ClassFlag.hidden.set( UserAccountBlock.inputBlock.query( e ) );
      ClassFlag.hidden.removeFrom( UserAccountBlock.invalidState.query( e ) );
      return;
    } 

    ClassFlag.hidden.removeFrom( UserAccountBlock.inputBlock.query( e ) );
    ClassFlag.clear( UserAccountBlock.inputBlock.query( e ) );
    
    let { id, email } = DeleteAccountUI.getEmailAndID(); 
    
    let data = new DeleteAccountData();
    data.tokenID = id;
    data.email = email;
    data.password = "";

    DeleteAccountUI._data.set( e, data );

    let inputs = ElementType.input.queryAll( e );

    let emailInput = UserAccountBlock.emailInput.find( inputs ) as HTMLInputElement;
    let nameInput  = UserAccountBlock.nameInput.find( inputs ) as HTMLInputElement;
    let pwInput    = UserAccountBlock.pwInput.find( inputs ) as HTMLInputElement; 

    UserAccountBlock.setInputFieldState( emailInput, true );
    UserAccountBlock.setReadonlyState( emailInput, true );

    emailInput.value = email;

    let createButton = UserAccountBlock.userButton.query( e ) as HTMLElement; 

    let checkInputs = () => 
    {
      console.log( "checking input" );
      data.password = pwInput.value;
      
      ClassFlag.enabled.setAs( createButton, data.valid );

      let messageAttribute = data.valid ? DeleteAccountUI.validInput : DeleteAccountUI.invalidInput;
      
      UserAccountBlock.setValidationMessage( e, messageAttribute );
      UserAccountBlock.setInputFieldState( pwInput, data.passwordIsValud );

    };


    this.attachInputListeners( nameInput, checkInputs );
    this.attachInputListeners( pwInput, checkInputs );

    checkInputs();

    
    OnClick.add( createButton,
      async ()=>
      { 
        console.log( "creating account", data );
        let tokenID  = data.tokenID;
        let email    = data.email;
        let password = data.password;

        let response = await Rokojori.$._oldPHPUser.delete( tokenID, email, password );

        let overlayContent:Element = null;

        if ( response.error )
        {
          overlayContent = DeleteAccountUI.errorContent.query( e );
        }
        else
        {
          overlayContent = DeleteAccountUI.successContent.query( e );
        }

        Overlay.show( overlayContent.cloneNode( true ) as HTMLElement );

        console.log( response );
      }
    );
    
  }

  static attachInputListeners( inputElement:HTMLInputElement, validator:()=>void )
  {
    OnChange.add( inputElement, validator );
    OnInput.add( inputElement, validator );

    UserAccountBlock.blurOnEnter( inputElement );
  }


}